import dayjs from 'dayjs'

// Spans 2 prior years through the end of the current year so operators can
// link tickets against prior-year periods. Newest month first.
export const buildPeriodMonthOptions = (): string[] => {
  const out: string[] = []
  const start = dayjs().startOf('year').subtract(2, 'year')
  for (let i = 0; i < 36; i += 1) {
    out.push(start.add(i, 'month').format('YYYY-MM-DD'))
  }
  return out.reverse()
}

export const isValidUrl = (url: string): boolean =>
  /^https?:\/\/.+/i.test(url.trim())
